export const IsOauthApp = () => location.pathname.startsWith('/oauth/account');
export const IsBilledApp = () => location.pathname.startsWith('/billed-usage-report');
export const IsPaymentApp = () => location.pathname.startsWith('/payment-methods');
export const IsSignupApp = () => window.location.pathname.toLowerCase().includes('signup');
export const IsPortalApp = () => window.location.pathname.toLowerCase().includes('portal');

export const AppHasAuth = () => !(IsSignupApp() || IsPortalApp() || IsBilledApp());
